import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate, useOutletContext } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { loadMetaCompany } from 'slices/company';
//api
import {
  getDetailBookStore,
  editBookStore,
  deleteBookStore
} from 'api/company';
//helpers
import { addToFormData } from 'helpers';
//components
import Title from 'components/backoffice/texts/title';
import BookStoreForm from 'components/backoffice/forms/bookstoreForm';

const EditBookStore = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [bookStore, setBookStore] = useState({});
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const companyState = useSelector(loadMetaCompany)
  const { t } = useTranslation(['backoffice']);
  const { setTitle } = useOutletContext()

  useEffect(() => {
    const detailBookStore = async () => {
      try {
        const { data, status } = await getDetailBookStore(id);
        if (status === 200) {
          setBookStore(data);
        }
      } catch (error) {
        console.log(error);
      }
    };
    detailBookStore();
  }, []);

  useEffect(() => {
    if (bookStore) {
      setTitle(t('edit', { title: bookStore?.name }))
    }
    return () => {
      setTitle('');
    };
  }, [bookStore])


  const onSubmit = async (values) => {
    setLoading(true);
    const socialsNetworks = {};
    const appsURLs = {};
    if (values.facebook !== '') {
      socialsNetworks.facebook = values.facebook;
    }
    if (values.twitter !== '') {
      socialsNetworks.twitter = values.twitter;
    }
    if (values.instagram !== '') {
      socialsNetworks.instagram = values.instagram;
    }
    if (values.google_play !== '') {
      appsURLs.google_play = values.google_play;
    }
    if (values.app_store !== '') {
      appsURLs.app_store = values.app_store;
    }

    const {
      code: validateCode = '',
      email: validateEmail = '',
      web_url: validateWebUrl = '',
      direccion: validateAddress = '',
      telefono: validatePhone = '',
      descripcion_pub: validateDescription = '',
      logo: validateLogo = bookStore.logo,
      latitude: validateLatitude = '',
      longitude: validateLongitude = '',
      business_hours: validateBusinessHour = '',
      service
    } = values;
    const formData = new FormData()

    const servicesData = service ? JSON.stringify([service.id]) : '[]';

    const items = {
      name: values.name,
      email: validateEmail,
      web_url: validateWebUrl,
      code: validateCode,
      direccion: validateAddress,
      telefono: validatePhone,
      descripcion_pub: validateDescription,
      logo: validateLogo,
      longitude: validateLongitude,
      latitude: validateLatitude,
      business_hours: validateBusinessHour,
      parent_affiliate: companyState.payload.company.id,
      redes_sociales: JSON.stringify(socialsNetworks),
      apps_urls: JSON.stringify(appsURLs),
      services_data: servicesData
    }

    if (typeof values.logo === 'string' && values.logo.startsWith('http')) {
      try {
        const response = await fetch(values.logo);
        const blob = await response.blob();
        const file = new File([blob], 'image.jpg', { type: blob.type });
        items.logo = file;
      } catch (error) {
        console.error('Error al convertir la imagen:', error);
      }
    }

    addToFormData(formData, items)

    try {
      const { status } = await editBookStore(id, formData);
      if (status === 200) {
        toast.success(t('editadocorrectamente'));
        navigate('/intranet/bookstores', { replace: true });
      } else {
        toast.error(`${t('error')} ${status}: ${t('mensajeerror')}`, { theme: 'colored' });
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  const handleDelete = useCallback(async () => {
    setLoading(true);
    try {
      const { status } = await deleteBookStore(id);
      if (status === 204) {
        toast.success(t('eliminadocorrectamente'));
        navigate('/intranet/bookstores', { replace: true });
      } else {
        toast.error(`${t('error')} ${status}: ${t('mensajeerror')}`, { theme: 'colored' });
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  }, [openModalDelete]);

  return (
    <div className="mt-2">
      <Title text={t('editbookstore')} />
      <BookStoreForm
        isEditing={true}
        onSubmitForm={onSubmit}
        openModalDelete={openModalDelete}
        setOpenModalDelete={setOpenModalDelete}
        defaultValues={bookStore}
        onDelete={handleDelete}
        id={id}
      />
    </div>
  );
};

export default EditBookStore;